import { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import _notification from './notification';
import search from './search';
import removeNulls from './removeNulls';
import useDebouncedEffect from '../useDebouncedEffect';

function useFilter(data, searchFilter, nullFilter) {
	const [filteredData, setFilteredData] = useState(null);
	const [notifyKey, setNotifyKey] = useState();
	const prevNotifyKey = useRef();
	const { t } = useTranslation();

	useEffect(() => {
		prevNotifyKey.current = notifyKey;
	});

	useDebouncedEffect(
		() => {
			if (!data) return;
			try {
				let processedData = data;

				if (searchFilter !== '') {
					processedData = search(data, searchFilter);
				}

				if (!nullFilter) {
					processedData = removeNulls(processedData);
				}

				setFilteredData(processedData);
			} catch (error) {
				console.error(error);
				setFilteredData(null);
				setNotifyKey(
					_notification({
						title: t('notification.info'),
						message: `String "${searchFilter}" not found with null filter: ${
							!nullFilter ? 'On' : 'Off'
						}.`,
						key: prevNotifyKey.current,
						onClose: () => setNotifyKey(undefined),
					})
				);
			}
		},
		[nullFilter, searchFilter, data],
		300
	);

	return filteredData;
}

export default useFilter;
